<template>
  <div>
    <h1 class="text-primary mb-4">{{ $t("global.new-customers-start-for-free") }}</h1>
    <div class="text-secondary mb-4">{{ $t("global.free-trial-desc") }}</div>
    <FreeTrialSignupForm
      :loading="loading"
      :email="email"
      @success="onSuccess"
      :enableBack="true"
      :backAction="back"
    />
  </div>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import FreeTrialSignupForm from "@/components/smart/forms/FreeTrialSignupForm";
import { fromServer } from "@/utils/translations";
import LoginModal from "@/components/smart/modals/LoginModal";
import store from "@/store";
import useAnalytics from "@/utils/useAnalytics";

export default {
  name: "CheckoutTrialProfilePage",
  components: {
    FreeTrialSignupForm,
  },
  setup(props, { root }) {
    const loading = ref(false);
    const email = computed(() => store.getters["checkout/getEmail"]);
    const requireStoreBuilder = computed(() => store.getters["checkout/requireStoreBuilder"]);
    const {
      cartData,
      // userData,
      orderDataFormat,
    } = useAnalytics();

    const back = () => {
      if (requireStoreBuilder.value) {
        root.$router.push({
          name: "checkout-free-trial-storebuilder",
          query: store.getters["checkout/getQueryParams"],
        });
      } else {
        root.$router.push({
          name: "checkout-free-trial-details",
          query: store.getters["checkout/getQueryParams"],
        });
      }
    };

    // after login, redirect to checkout-package page
    const onLogin = () => {
      root.$router.push({ name: "checkout-package" });
    };

    // open login modal
    const login = () => {
      store.dispatch("modals/open", {
        template: LoginModal,
        confirm: onLogin,
      });
    };

    const onSuccess = (userFormData) => {
      loading.value = true;
      const { packageId, appId, locationId, nickname } = store.state.checkout;

      store.dispatch("analytics/send", { name: "checkoutPurchaseInitiated", data: cartData.value });

      store
        .dispatch("checkout/createPlan", {
          packageId,
          appId,
          locationId,
          nickname,
          installApp: true,
        })
        .then((data) => {
          console.log("checkout trial order", { data, userFormData });
          store.dispatch("analytics/send", { name: "checkoutBillingInfo", data: cartData.value });
          store.dispatch("analytics/send", {
            name: "checkoutPurchaseCompleted",
            data: {
              cartData: { ...cartData.value },
              userData: {
                userId: userFormData?.id,
                clientId: data?.order?.client_id,
                billingId: null,
                firstName: userFormData?.firstName,
                lastName: userFormData?.lastName,
                email: userFormData?.email,
              },
              orderData: orderDataFormat(
                data,
                store.state.checkout.couponCode,
                store.state.checkout.discount
              ),
            },
          });
          store.dispatch("analytics/send", {
            name: "navigation",
            data: {
              fullPath: "/thank-you-free-trial",
              meta: { title: "Free Trial Checkout Thank You" },
            },
          });
          store.dispatch("cartstack/confirm");

          root.$router.push({ name: "plans" });
        })
        .catch((e) => {
          console.log("checkout trial error", { e });
          const errors = fromServer(e.request.response);
          if (Array.isArray(errors)) {
            errors.forEach((error) =>
              store.dispatch("toasts/addToast", {
                variant: "error",
                message: error,
                timeout: true,
              })
            );
          } else {
            store.dispatch("toasts/addToast", {
              variant: "error",
              message: errors,
              timeout: true,
            });
          }
        })
        .finally(() => {
          loading.value = false;
        });
    };

    return { login, onSuccess, email, loading, back };
  },
};
</script>
